module.exports = __webpack_public_path__ + "img/EQUAL.5bac4860.svg";